import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { chargebacksShape } from '../../../utils/propTypes';
import ColorDollarAmountCell from '../../Table/Cells/ColorDollarAmountCell/ColorDollarAmountCell';
import { currencyMapper } from '@nexio/emvio-util-app';
import { get } from 'lodash';
import './ChargebacksListItem.scss';
import { prettifyDate } from '../../../utils/string';

export default class ChargebacksListItem extends Component {
    static propTypes = {
        item: chargebacksShape.isRequired,
        onGoToItem: PropTypes.func.isRequired
    };

    renderDate(date) {
        return date ? prettifyDate(date, { returnDateOnly: true }) : 'No Date';
    }

    renderMerchant(merchantName) {
        return merchantName ? merchantName : 'No Merchant';
    }

    render() {
        const chargeback = this.props.item;
        const currencyCode = get(currencyMapper, chargeback.currencyId, '840').code;

        return (
            <div
                className="chargebacks-list-item"
                onClick={this.props.onGoToItem}
            >
                <div className="chargebacks-list-item-left">
                    <span className="chargebacks-date">
                        {this.renderDate(chargeback.reportDate)}
                    </span>
                    <span className="chargebacks-merchant">
                        {this.renderMerchant(chargeback.merchantName)}
                    </span>
                </div>
                <div className="chargebacks-list-item-right">
                    <span className="chargebacks-amount">
                        <ColorDollarAmountCell amount={chargeback.amount} currencyCode={currencyCode}/>
                    </span>
                </div>
            </div>
        );
    }
}
